module.exports = __webpack_public_path__ + "static/media/Vec vectores_TC gris.7e34bdd9.svg";